import { z } from "zod";

import {
  EMAIL_REQUIRED_MESSAGE,
  EMAIL_MAX_LENGTH_MESSAGE,
  EMAIL_FORMAT_MESSAGE,
  PASSWORD_REQUIRED_MESSAGE,
  FAMILY_NAME_REQUIRED_MESSAGE,
  FIRST_NAME_REQUIRED_MESSAGE,
  FAMILY_NAME_KANA_REQUIRED_MESSAGE,
  FIRST_NAME_KANA_REQUIRED_MESSAGE,
  KANA_FORMAT_MESSAGE,
  NAME_MAX_LENGTH_MESSAGE,
} from "./message";
import { EMAIL_REGEX, MAX_EMAIL_LENGTH, PASSWORD_REGEX, MAX_NAME_LENGTH, NAME_KANA_REGEX } from "./patterns";
import { smsPhoneNumberSchema } from "./phoneNumber";

const registerBaseObjectSchema = z.object({
  family_name: z
    .string({ required_error: FAMILY_NAME_REQUIRED_MESSAGE })
    .min(1, FAMILY_NAME_REQUIRED_MESSAGE)
    .max(MAX_NAME_LENGTH, NAME_MAX_LENGTH_MESSAGE),

  first_name: z
    .string({ required_error: FIRST_NAME_REQUIRED_MESSAGE })
    .min(1, FIRST_NAME_REQUIRED_MESSAGE)
    .max(MAX_NAME_LENGTH, NAME_MAX_LENGTH_MESSAGE),

  family_name_kana: z
    .string({ required_error: FAMILY_NAME_KANA_REQUIRED_MESSAGE })
    .min(1, FAMILY_NAME_KANA_REQUIRED_MESSAGE)
    .max(MAX_NAME_LENGTH, NAME_MAX_LENGTH_MESSAGE)
    .regex(NAME_KANA_REGEX, KANA_FORMAT_MESSAGE),

  first_name_kana: z
    .string({ required_error: FIRST_NAME_KANA_REQUIRED_MESSAGE })
    .min(1, FIRST_NAME_KANA_REQUIRED_MESSAGE)
    .max(MAX_NAME_LENGTH, NAME_MAX_LENGTH_MESSAGE)
    .regex(NAME_KANA_REGEX, KANA_FORMAT_MESSAGE),

  email: z
    .string()
    .min(1, EMAIL_REQUIRED_MESSAGE)
    .max(MAX_EMAIL_LENGTH, EMAIL_MAX_LENGTH_MESSAGE)
    .regex(EMAIL_REGEX, EMAIL_FORMAT_MESSAGE),

  password: z.string().min(1, PASSWORD_REQUIRED_MESSAGE).regex(PASSWORD_REGEX, {
    message:
      "※8～72文字の間で設定してください。<br/>※半角英字、半角数字の2種類を使用してください。<br/>【使用可能な記号 】 !\"#$%&''()-^@[;:",
  }),

  password_confirmation: z.string().optional(),

  request_the_proposal: z.boolean(),
});

// 電話番号入力用スキーマ
export const registerPhoneSchema = z.object({
  phone_number: smsPhoneNumberSchema,
});

// SMS認証コード入力用スキーマ
export const registerSmsCodeSchema = z.object({
  phone_number_auth_code: z.number(),
});

// ユーザー登録基本情報用スキーマ
export const registerBasicSchema = registerBaseObjectSchema;

// 全体の登録フォーム用スキーマ（個別スキーマをマージ）
export const registerFullSchema = registerBaseObjectSchema.merge(registerPhoneSchema).merge(registerSmsCodeSchema);

export type RegisterBasicFormData = z.infer<typeof registerBasicSchema>;
export type RegisterPhoneFormData = z.infer<typeof registerPhoneSchema>;
export type RegisterSmsCodeFormData = z.infer<typeof registerSmsCodeSchema>;
export type RegisterFullFormData = z.infer<typeof registerFullSchema>;
